// StatusChangeModal.jsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./statusChangeModal.css";
import vector from "../../Assets/Icons/Vector.png";
import vectorr from "../../Assets/Icons/Vectorr.png";

const StatusChangeModal = ({ showModal, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    if (showModal) {
      setVisible(true);
    }
  }, [showModal]);

  const handleCloseWithTransition = (callback) => {
    setVisible(false);
    setTimeout(() => {
      callback();
    }, 300);
  };

  if (!showModal && !visible) return null;

  return (
    <div className="status-modal-overlay">
      <div className={`status-modal ${visible ? "open" : "close"}`}>
        <div className="status-modal-header">{t("changeNurseStatus")}</div>
        <div className="status-modal-sub">{t("setInactive")}</div>

        {/* <div className="status-modal-dates">
          <div className="date-field">
            <label>{t("startDate")}</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="arrow-wrapper">
            <img src={vector} alt="arrow left" className="status-arrow" />
            <img src={vectorr} alt="arrow right" className="status-arrow" />
          </div>

          <div className="date-field">
            <label>{t("endDate")}</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div> */}

        {/* <div className="status-modal-warning">
          {t("nurseStatusWarning", {
            start: startDate || "--/--/----",
            end: endDate || "--/--/----",
          })}
        </div> */}

        <div className="status-modal-actions">
          <button
            className="status-cancel-btn"
            onClick={() => handleCloseWithTransition(onCancel)}
          >
            {t("cancel")}
          </button>

          <button
            className="status-confirm-btn"
            // onClick={() => handleCloseWithTransition(() => onConfirm({ startDate, endDate }))}
            // disabled={!startDate || !endDate}
          >
            {t("confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusChangeModal;